import { useEffect, useState } from 'react'
import queryString from 'query-string'
import { WalletTypes } from 'types/types'

export const useIsCryptoBatch = (walletType: WalletTypes) => {
  const [isCryptoBatch, setIsCryptoBatch] = useState(false)

  useEffect(() => {
    const { batchType }: { batchType?: string } = queryString.parse(window.location.search)

    setIsCryptoBatch(walletType === WalletTypes.CRYPTO && batchType === WalletTypes.CRYPTO)
  }, [queryString.parse(window.location.search)])

  return isCryptoBatch
}
